/**
 * One entry of an integrations export request: a procedure plus the version of
 * it that has to be exported.
 */
export type ProcedureVersionExportSelection = {
    procedureId: string;
    /** `null` means "whatever the latest available version is at export time". */
    versionId: string | null;
};

/** Sentinel used by the version dropdown for the "Latest" option. */
export const LATEST_VERSION_ID = 'latest';
